var exports = {
  "element": "xe564cbfb--25b7f7--element",
  "element-background_color--transparent": "xe564cbfb--25b7f7--element-background_color--transparent",
  "element-background_color--black": "xe564cbfb--25b7f7--element-background_color--black",
  "element-background_color--white": "xe564cbfb--25b7f7--element-background_color--white",
  "element-background_color--gray_0": "xe564cbfb--25b7f7--element-background_color--gray_0",
  "element-background_color--gray_1": "xe564cbfb--25b7f7--element-background_color--gray_1",
  "element-background_color--gray_2": "xe564cbfb--25b7f7--element-background_color--gray_2",
  "element-background_color--gray_3": "xe564cbfb--25b7f7--element-background_color--gray_3",
  "element-background_color--gray_4": "xe564cbfb--25b7f7--element-background_color--gray_4",
  "element-background_color--blue": "xe564cbfb--25b7f7--element-background_color--blue",
  "element-background_color--pink": "xe564cbfb--25b7f7--element-background_color--pink",
  "element-background_color--green": "xe564cbfb--25b7f7--element-background_color--green",
  "element-background_color--red": "xe564cbfb--25b7f7--element-background_color--red",
  "element-background_color--orange": "xe564cbfb--25b7f7--element-background_color--orange",
  "element-background_color--yellow": "xe564cbfb--25b7f7--element-background_color--yellow",
};

module.exports = exports;
